/*
 * Search page box (sections/ll-search.liquid): live product suggestions while typing.
 * Suggestions come from Shopify predictive search, rendered by sections/ll-search-suggest.liquid.
 */
(function () {
  if (customElements.get('ll-search-box')) return;

  var MIN_CHARS = 2;
  var DELAY = 220;

  class LlSearchBox extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-ll-search-form]');
      this.input = this.querySelector('[data-ll-search-input]');
      this.clear = this.querySelector('[data-ll-search-clear]');
      this.panel = this.querySelector('[data-ll-search-suggest]');
      if (!this.form || !this.input || !this.panel) return;

      this.url = this.dataset.suggestUrl || '/search/suggest';
      this.section = this.dataset.section || 'll-search-suggest';
      this.cache = {};
      this.timer = null;
      this.controller = null;
      this.active = -1;

      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('keydown', this.onKeydown.bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));

      if (this.clear) {
        this.clear.addEventListener('click', this.onClear.bind(this));
      }

      this.form.addEventListener('submit', (event) => {
        if (!this.input.value.trim()) {
          event.preventDefault();
          this.input.focus();
        }
      });

      this.onDocClick = (event) => {
        if (!this.contains(event.target)) this.close();
      };
      document.addEventListener('click', this.onDocClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
    }

    get terms() {
      return this.input.value.trim();
    }

    onInput() {
      if (this.clear) this.clear.classList.toggle('is-hidden', this.input.value === '');
      clearTimeout(this.timer);

      if (this.terms.length < MIN_CHARS) {
        this.close();
        return;
      }

      this.timer = setTimeout(() => this.fetchSuggestions(this.terms), DELAY);
    }

    onFocus() {
      // Show the last suggestions again when coming back to the box
      if (this.terms.length >= MIN_CHARS && this.panel.innerHTML.trim() !== '') {
        this.open();
      }
    }

    onClear() {
      this.input.value = '';
      this.clear.classList.add('is-hidden');
      this.close();
      this.panel.innerHTML = '';
      this.input.focus();
    }

    fetchSuggestions(terms) {
      var key = terms.toLowerCase();
      if (this.cache[key]) {
        this.render(this.cache[key]);
        return;
      }

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.classList.add('is-loading');

      var params = new URLSearchParams();
      params.set('q', terms);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '6');
      params.set('resources[options][prefix]', 'last');
      params.set('resources[options][unavailable_products]', 'last');
      params.set('section_id', this.section);

      fetch(this.url + '?' + params.toString(), { signal: this.controller.signal })
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var content = doc.querySelector('.ll-suggest');
          var html = content ? content.outerHTML : '';
          this.cache[key] = html;
          // Ignore answers for terms the customer has already typed past
          if (this.terms.toLowerCase() === key) this.render(html);
        })
        .catch((error) => {
          if (error.name !== 'AbortError') this.close();
        })
        .finally(() => {
          this.classList.remove('is-loading');
        });
    }

    render(html) {
      if (!html) {
        this.close();
        return;
      }
      this.panel.innerHTML = html;
      this.active = -1;
      this.open();
    }

    open() {
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open');
    }

    close() {
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-open');
      this.setActive(-1);
    }

    options() {
      return Array.prototype.slice.call(this.panel.querySelectorAll('.ll-suggest__item, .ll-suggest__all'));
    }

    setActive(index) {
      var items = this.options();
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === index);
        var li = item.closest('[role="option"]');
        if (li) li.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      this.active = index;
      if (index > -1 && items[index]) {
        items[index].scrollIntoView({ block: 'nearest' });
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        return;
      }

      if (this.panel.hidden) return;
      var items = this.options();
      if (!items.length) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.setActive(this.active + 1 >= items.length ? 0 : this.active + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.setActive(this.active - 1 < 0 ? items.length - 1 : this.active - 1);
      } else if (event.key === 'Enter' && this.active > -1 && items[this.active]) {
        event.preventDefault();
        window.location.href = items[this.active].href;
      }
    }
  }

  customElements.define('ll-search-box', LlSearchBox);
})();
